import React, { Fragment, useState } from "react";
import Image from "react-bootstrap/Image";
import moment from "moment";
import CallingButtonPopup from "../../../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import SendSmsButton from "../../../../../reusableComponents/allPopupReusable/SendSmsButton";
import NotificationButton from "../../../../../reusableComponents/allPopupReusable/NotificationButton";
import { PopupIconButtonReusable } from "../../../../../reusableComponents/allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";
// import ViewButtonPopup from "../../allPopupReusable/ViewButtonPopup";
// import EditDiner from "../../allPopupReusable/editDinerAndEditReservaion/EditDiner";
// import DeletePopup from "../../allPopupReusable/smallPopup/DeletePopup";
import LocationReusable from "../../../../../reusableComponents/allPopupReusable/locationReusablePopup/LocationReusable";
import EditWaitTime from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/EditWaitTime";
import NewCountDown from "../../../../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";
import EditDiner from "../../../../../vendorDashboardComponents/seatingDashboard/EditDiner";
import ViewDiner from "../../../../../vendorDashboardComponents/seatingDashboard/ViewDiner";
import StatusChangeAction from "../popup/StatusChangeAction";

export const SuperAdminSeatingTableBody = (props) => {
  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(props.dinerInfo.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  const updatedTime = new Date(
    props.dinerInfo.wait_time_date || props.dinerInfo.updatedAt
  );
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNew = updatedTime.getTime();
  const waitTime = props.dinerInfo.wait_time * 60 * 1000;
  let updateWaitTime = updatedTimeNew + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  const seatedTime = new Date(props.dinerInfo.seatedTime);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " hh : " + nMinutesSeated + " mins";
  }

  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  return (
    <Fragment>
      {/* <div className="seating-dashboard-body"> */}
      <tbody className="w-100 seating-dashboard-body-new">
        <tr className="w-100 p-0">
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css">
                <tr
                  className={`cursor enGrayBorderBox sd_body_tr ${
                    props.dinerInfo.service_type === "RESERVATION"
                      ? "td_b_o"
                      : "td_b_g"
                  }`}
                  onClick={showTr}
                >
                  <td
                    className={
                      props.dinerInfo.isWalkIn === true ||
                      props.dinerInfo.isWalkIn === false
                        ? "td_b_g order-type-Image"
                        : "td_b_o order-type-Image"
                    }
                    style={{ width: "6%" }}
                  >
                    {props.dinerInfo.isWalkIn === true &&
                    props.dinerInfo.service_type === "SEATING" ? (
                      <Image
                        src={require("../../../../../../assets/images/ActionImages/image/walkin.svg")}
                        alt="Order Type"
                        title="Order Type"
                      />
                    ) : null ||
                      (props.dinerInfo.isWalkIn === false &&
                        props.dinerInfo.service_type === "SEATING") ? (
                      <Image
                        src={require("../../../../../../assets/images/ActionImages/image/waitlist.svg")}
                        alt="Order Type"
                        title="Order Type"
                      />
                    ) : null ||
                      props.dinerInfo.service_type === "RESERVATION" ? (
                      <Image
                        src={require("../../../../../../assets/images/ActionImages/image/reservation.svg")}
                        alt="Order Type"
                        title="Order Type"
                      />
                    ) : null}
                  </td>
                  <td style={{ width: "20%" }}>
                    <h4 className="font_20_m">{props.dinerName}</h4>
                    <p className="font_12_r">#{props.dinerInfo.diner_id}</p>
                  </td>
                  <td style={{ width: "12%" }}>
                    <div className="total-pax-body">
                      <div className="col d-flex p-0">
                        <div className="total-pax-body-inside">
                          <h4 className="font_24_b">
                            {props.dinerInfo.adult_count +
                              props.dinerInfo.kids_count}
                          </h4>
                          {/* <p className="total-pax-light-text">PAX</p> */}
                        </div>
                        <div className="total-adult-kids">
                          <div className="display-align">
                            <Image
                              src={require("../../../../../../assets/images/ActionImages/image/adult.svg")}
                              alt="Adult"
                              title="Adult"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props.dinerInfo.adult_count}
                            </p>
                          </div>
                          <div className="display-align">
                            <Image
                              src={require("../../../../../../assets/images/ActionImages/image/kids.svg")}
                              alt="Kids"
                              title="Kids"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props.dinerInfo.kids_count}
                            </p>
                          </div>
                        </div>
                        <div className="total-highchair-handicapp">
                          {/* {props.dinerInfo.high_chair === 0 ? null : ( */}
                          <div className="display-align">
                            <Image
                              src={require("../../../../../../assets/images/ActionImages/image/highchair.svg")}
                              alt="Highchair"
                              title="Highchair"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props.dinerInfo.high_chair}
                            </p>
                          </div>
                          {/* )}
                    {props.dinerInfo.handicap_chair === 0 ? null : ( */}
                          <div className="display-align">
                            <Image
                              src={require("../../../../../../assets/images/ActionImages/image/handicap.svg")}
                              alt="Handicapped"
                              title="Handicapped"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props.dinerInfo.handicap_chair}
                            </p>
                          </div>
                          {/* )} */}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="date-time-timer-body">
                      <div className="time-and-edit-button">
                        <div className="timer-section mr-2">
                          <h4 className="timer-count">
                            <NewCountDown waitNew={diff} />
                          </h4>
                        </div>
                        {props.dinerInfo.diner_status === "SEATED" ? (
                          ""
                        ) : (
                          <EditWaitTime allDataProps={props.dinerInfo._id} />
                        )}
                      </div>
                    </div>
                    <p className="font_20_r">
                      {props.dinerInfo.service_type === "RESERVATION"
                        ? moment(props.dinerInfo.reservationTime).format(
                            "Do MMM YYYY"
                          )
                        : moment(props.dinerInfo.createdAt).format(
                            "Do MMM YYYY"
                          )}
                    </p>
                    <p className="font_20_r">
                      {props.dinerInfo.service_type === "RESERVATION"
                        ? moment(props.dinerInfo.reservationTime).format(
                            "hh:mm A"
                          )
                        : moment(props.dinerInfo.createdAt).format("hh:mm A")}
                    </p>
                  </td>
                  <td style={{ width: "15%" }}>
                    <h4 className="font_20_m">
                      {props.dinerInfo.seating_preference[0]}
                    </h4>
                  </td>
                  <td style={{ width: "32%" }}>
                    <div
                      className={
                        props.displayButton === true
                          ? "action-section-body d-flex align-items-center justify-content-center"
                          : "action-section-body align-items-center"
                      }
                    >
                      {props.dinerInfo.diner_status === "SEATED" ? (
                        <div>
                          <StatusChangeAction
                            buttonDisplay="smallCancelButton"
                            displayPopup="seatingUnseated"
                            buttonText="Unseat"
                            bigText="Request Unseat"
                            display={true}
                            reasonText="Are you sure to Unseat ?"
                            dataSend={props.dinerInfo}
                          />
                        </div>
                      ) : (
                        <div>
                          <StatusChangeAction
                            buttonDisplay="smallCancelButton"
                            displayPopup="resonFforCancellation"
                            actionCall={"seatingDashboardSide"}
                            buttonText="Cancel"
                            bigText="Request Cancel"
                            reasonText="Are you sure to Cancel ?"
                            dataSend={props.dinerInfo}
                          />
                        </div>
                      )}
                      <div className="middle-timer">
                        <p className="font_12_r">Total Wait time</p>
                        <div className="count-down-timer d-flex">
                          <i
                            className="fa fa-hourglass-half mr-3"
                            aria-hidden="true"
                          ></i>
                          <p className="font_16_m">
                            {props.dinerInfo.diner_status === "NOTSEATED"
                              ? time_convert(minutes)
                              : seated_time_difference(minutesSeated)}
                          </p>
                        </div>
                        <p className="font_20_r">
                          Status:&nbsp;
                          <span className="font_18_b">
                            {props.dinerInfo.diner_status === "NOTSEATED"
                              ? "NOT SEATED"
                              : "SEATED"}
                          </span>
                        </p>
                      </div>
                      {props.dinerInfo.diner_status === "SEATED" ? (
                        <div>
                          <StatusChangeAction
                            buttonDisplay="smallSaveButton"
                            displayPopup="seatingCompleted"
                            buttonText="Complete"
                            bigText="Request Complete"
                            reasonText="Are you sure to Completed ?"
                            dataSend={props.dinerInfo}
                          />
                        </div>
                      ) : (
                        <div>
                          <StatusChangeAction
                            buttonDisplay="smallSaveButton"
                            displayPopup="SeatedButton"
                            buttonText="Seat"
                            bigText="Request Seated"
                            reasonText="Are you sure to Seated ?"
                            dataSend={props.dinerInfo}
                          />
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
                {TrDetail.TrDetail && (
                  <tr className="sd_accordion_body">
                    <td className="sd_accordion_td_1">
                      <h4 className="font_20_m c_red">More details</h4>
                      <div className="d-flex justify-content-between mt-3 mr-3">
                        {props.displayCall === true ? (
                          <CallingButtonPopup buttonClass="smallButton" />
                        ) : null}
                        {props.displaySms === true ? (
                          <SendSmsButton
                            dataSend={props.dinerInfo}
                            buttonClass="smallButton"
                          />
                        ) : null}
                        {props.displayNotification === true ? (
                          <NotificationButton
                            buttonClass="smallButton"
                            dataSend={props.dinerInfo}
                          />
                        ) : null}
                        {props.displayChat === true ? (
                          <PopupIconButtonReusable
                            buttonClass={"smallButton"}
                            titleText="Send Sms Button"
                            image={require("../../../../../../assets/images/ActionImages/chat.png")}
                            // onClick={this.onOpenModal}
                          />
                        ) : null}
                        {props.displayViewDiner === true ? (
                          // <ViewButtonPopup
                          //   dataSend={props.dinerInfo}
                          //   buttonClass="smallButton"
                          // />
                          <ViewDiner dataSend={props.dinerInfo} />
                        ) : null}
                        {props.displayEditDiner === true ? (
                          <EditDiner
                            buttonClass="smallButton"
                            dataSend={props.dinerInfo}
                            bigText="Edit Diner"
                          />
                        ) : null}
                      </div>
                    </td>
                    <td className="sd_accordion_td_2">
                      <h4 className="font_20_m">Track User Location</h4>
                      <LocationReusable dataSend={props.dinerInfo} />
                    </td>
                    <td className="sd_accordion_td_3">
                      <h4 className="font_20_m">Date & Time</h4>
                      <div className="mt-3">
                        <p className="font_16_r">
                          {props.dinerInfo.service_type === "RESERVATION"
                            ? moment(props.dinerInfo.reservationTime).format(
                                "Do MMM YYYY"
                              )
                            : moment(props.dinerInfo.createdAt).format(
                                "Do MMM YYYY"
                              )}
                        </p>
                        <p className="font_16_r">
                          {props.dinerInfo.service_type === "RESERVATION"
                            ? moment(props.dinerInfo.reservationTime).format(
                                "hh:mm A"
                              )
                            : moment(props.dinerInfo.createdAt).format(
                                "hh:mm A"
                              )}
                        </p>
                      </div>
                    </td>
                    <td className="sd_accordion_td_4">
                      <h4 className="font_20_m">Table / Room No.</h4>
                      <div className="mt-3">
                        <p className="font_16_r">
                          Room No. -{" "}
                          {props.dinerInfo.room_number === null && undefined
                            ? ""
                            : props.dinerInfo.room_number}
                        </p>
                        <p className="font_16_r">
                          Table No. -{" "}
                          {props.dinerInfo.table_number === null && undefined
                            ? ""
                            : props.dinerInfo.table_number}
                        </p>
                      </div>
                    </td>
                    <td className="sd_accordion_td_5">
                      <h4 className="font_20_m">Special Occasion</h4>
                      <div className="d-flex mt-3">
                        <p className="font_16_r">
                          {props.dinerInfo.occasion}
                          {/* {props.dinerInfo.occasion.length > 65 ? (
                            <span className="c_orange">&nbsp;see more</span>
                          ) : (
                            ""
                          )} */}
                        </p>
                      </div>
                    </td>
                    <td className="sd_accordion_td_6">
                      <h4 className="font_20_m">Status</h4>
                      <div className="d-flex mt-3">
                        <div
                          className={`${
                            props.dinerInfo.diner_status === "NOTSEATED"
                              ? "b_c_orange"
                              : props.dinerInfo.diner_status === "SEATED"
                              ? "b_c_light_green"
                              : props.dinerInfo.diner_status === "CANCELLED" ||
                                props.dinerInfo.diner_status === "REJECTED"
                              ? "b_c_red"
                              : props.dinerInfo.diner_status === "COMPLETED"
                              ? "b_c_green"
                              : "b_c_orange"
                          } status_blink_box`}
                        ></div>
                        <p className="font_16_m">
                          {props.dinerInfo.diner_status}
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </Fragment>
  );
};
